import type { NotificationItem } from '@/types'

export const NOTIFICATIONS: NotificationItem[] = [
    {
        id: 'n1',
        kind: 'approved',
        text: 'نسخه جدید دانش شما پس از بازبینی منتشر شد',
        target: 'راهنمای استاندارد طراحی API در سامانه‌های بانکی',
        time: 'دیروز',
        href: '/knowledge/api-design-standard',
        unread: true
    },
    {
        id: 'n2',
        kind: 'comment',
        text: 'رضا احمدی روی دانش شما نظر داد',
        target: 'معماری مرجع میکروسرویس‌ها در سامانه‌های پرداخت',
        time: 'دیروز',
        href: '/knowledge/microservices-reference-architecture#comments',
        unread: true
    },
    {
        id: 'n3',
        kind: 'returned',
        text: 'بازبین درخواست اصلاح داده است',
        target: 'استاندارد نام‌گذاری رویدادها در Kafka',
        time: '۷ روز پیش',
        href: '/knowledge/kafka-event-naming',
        unread: true
    },
    {
        id: 'n4',
        kind: 'new',
        text: 'دانش جدید در حوزه دانش فنی و تخصصی',
        target: 'دستورالعمل بررسی خطاهای ارتباطی سرویس‌های پرداخت',
        time: '۶ روز پیش',
        href: '/knowledge/payment-connectivity-errors',
        unread: false
    },
    {
        id: 'n5',
        kind: 'mention',
        text: 'نگار صالحی به نظر شما پاسخ داد',
        target: 'چک‌لیست امنیتی پیش از استقرار سرویس‌ها در محیط عملیاتی',
        time: '۲ هفته پیش',
        href: '/knowledge/security-predeploy-checklist#comments',
        unread: false
    }
]
